import { render, staticRenderFns } from "./BuyPaymentWx.vue?vue&type=template&id=01e5723f&scoped=true&"
import script from "./BuyPaymentWx.vue?vue&type=script&lang=js&"
export * from "./BuyPaymentWx.vue?vue&type=script&lang=js&"
import style0 from "./BuyPaymentWx.vue?vue&type=style&index=0&id=01e5723f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5723f",
  null
  
)

export default component.exports